import { GET_STATION_REPAIR_WORK } from "../apiEndpoints";
import DialogBox from "../../../components/UI/DialogBox";
import spin from "../../../assets/icons/spin.png";
import { useSelector } from "react-redux";
import { handleErrMessage } from "../../../functions/handleErrMessage";
import MainPageLayout from "../../../layout/MainPageLayout";
import useFetchData from "../../../CustomHooks/useAxios/useFetchData";
import StationRepairList from "../components/stationRepairs/StationRepairList";

export const StationRepairsPage = () => {
  const { isLoaded } = useFetchData(GET_STATION_REPAIR_WORK);
  const data = useSelector((state) => state.data.data);
  const error = useSelector((state) => state.data.error);
  const errMsg = useSelector((state) => state.data.errMessage);
  const dataLength = isLoaded && !errMsg ? data.length : 0;

  return (
    <MainPageLayout
      headerConfig={{ title: "Station Repairs" }}
      numberOfData={dataLength}
    >
      {isLoaded && !error ? (
        <StationRepairList />
      ) : error ? (
        <DialogBox
          title="Error"
          message={handleErrMessage(errMsg)}
          isErrorHandleButtons={true}
        />
      ) : (
        <DialogBox message="Loading your data" animateIcon={spin} />
      )}
    </MainPageLayout>
  );
};
